import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const KEY = "sme-cookie-consent";

export const CookieConsent = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const t = setTimeout(() => setShow(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const decide = (choice) => {
    localStorage.setItem(KEY, JSON.stringify({ choice, at: new Date().toISOString() }));
    setShow(false);
    if (choice === "all") { import("@/lib/analytics").then((a) => { a.initGA(); a.grantAnalyticsConsent(); }); }
  };

  if (!show) return null;
  return (
    <div
      className="fixed bottom-5 left-5 right-5 sm:left-auto sm:max-w-[380px] z-[90] bg-ink text-cream border border-cream/15 grain p-5 shadow-2xl animate-in fade-in slide-in-from-bottom-4 duration-500"
      role="dialog" aria-label="Cookie notice" data-testid="cookie-banner"
    >
      <p className="overline text-gloss-gold text-[10px] mb-2">A quiet word</p>
      <p className="font-sans text-sm text-cream/80 leading-relaxed">
        We use only the cookies needed to keep the magazine working — no ad trackers, ever.{" "}
        <Link to="/cookies" className="underline underline-offset-2 hover:text-gloss-gold" data-testid="cookie-policy-link">The full story</Link>.
      </p>
      <div className="flex gap-2 mt-4">
        <button onClick={() => decide("all")}
          className="flex-1 bg-cream text-ink px-4 py-2.5 overline text-[10px] hover:bg-gloss-gold transition-colors" data-testid="cookie-accept-btn">
          That's fine
        </button>
        <button onClick={() => decide("essential")}
          className="flex-1 border border-cream/40 px-4 py-2.5 overline text-[10px] hover:border-cream transition-colors" data-testid="cookie-essential-btn">
          Essential only
        </button>
      </div>
    </div>
  );
};
